import { addParamsToUrl } from '@zapier/url-utils';
import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildPlanChangeUrl = (
  changeType: string,
  fromPlanName: string,
  toPlanName: string = '',
  selectedInterval?: Interval,
  selectedCurrency?: string
): string => {
  let url = `/app/billing/plans/${changeType}/${fromPlanName.toLocaleLowerCase()}`;

  if (changeType !== 'change') {
    url += `/${toPlanName.toLocaleLowerCase()}`;
  }

  url = addParamsToUrl(
    url,
    { interval: selectedInterval, currency: selectedCurrency },
    true
  );

  return encodeURI(url);
};
